import { callRpc } from './base';
import type {
  AwardIngestionJobDetail,
  AwardIngestionStatusResponse,
  AwardReviewDecisionPayload,
  AwardReviewDecisionResult,
  AwardReviewQueueFilters,
  AwardReviewQueueItem,
} from '../../types/rpc-contracts';

export const getAwardIngestionStatus = async (): Promise<AwardIngestionStatusResponse> => {
  return await callRpc<AwardIngestionStatusResponse>('get_award_ingestion_status');
};

export const getAwardJobDetail = async (jobId: string): Promise<AwardIngestionJobDetail> => {
  return await callRpc<AwardIngestionJobDetail>('get_award_job_detail', {
    params: {
      job_id: jobId,
    },
  });
};

export const enqueueAwardRecrawl = async (sourceUrl: string): Promise<{ job_id: string }> => {
  return await callRpc<{ job_id: string }>('enqueue_award_recrawl', {
    params: {
      source_url: sourceUrl,
    },
  });
};

export const assignAwardIngestionJob = async (jobId: string, assigneeId: string | null): Promise<void> => {
  await callRpc('assign_award_ingestion_job', {
    params: {
      job_id: jobId,
      assignee_id: assigneeId,
    },
    transform: () => undefined,
  });
};

export const listAwardReviewQueue = async (
  filters?: AwardReviewQueueFilters,
): Promise<AwardReviewQueueItem[]> => {
  return await callRpc<AwardReviewQueueItem[]>('list_award_review_queue', {
    params: filters as Record<string, unknown> | undefined,
  });
};

export const resolveAwardField = async (
  payload: AwardReviewDecisionPayload,
): Promise<AwardReviewDecisionResult> => {
  return await callRpc<AwardReviewDecisionResult>('resolve_award_field', {
    params: payload as unknown as Record<string, unknown>,
  });
};
